import React from "react";
import { Plus } from "@phosphor-icons/react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const ORDER_STATUSES = ["Placed", "Processing", "Completed", "Cancelled"];

export default function OrdersTab({ orders, onAdd, onStatusChange }) {
  return (
    <div className="bg-white border border-slate-200 rounded-lg">
      <div className="px-6 py-4 border-b border-slate-200 flex items-center justify-between">
        <h3 className="font-heading font-semibold text-slate-900">Orders</h3>
        <button
          onClick={onAdd}
          data-testid="new-order-button"
          className="inline-flex items-center gap-2 px-3 h-9 rounded-md bg-blue-600 text-white text-sm font-medium hover:bg-blue-700"
        >
          <Plus size={16} weight="bold" /> Add Order
        </button>
      </div>
      {orders.length === 0 ? (
        <div className="px-6 py-12 text-center text-sm text-slate-500">
          No orders yet.
        </div>
      ) : (
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200 text-left text-[11px] uppercase tracking-[0.18em] text-slate-500">
            <tr>
              <th className="px-6 py-3">Order</th>
              <th className="px-6 py-3">Amount</th>
              <th className="px-6 py-3">Status</th>
              <th className="px-6 py-3">Date</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {orders.map((o) => (
              <tr key={o.id} data-testid={`order-row-${o.id}`}>
                <td className="px-6 py-3">
                  <div className="font-medium text-slate-900">{o.order_code}</div>
                  <div className="text-xs text-slate-500">{o.description}</div>
                </td>
                <td className="px-6 py-3 text-slate-800 font-medium">
                  ₹{Number(o.amount).toLocaleString("en-IN")}
                </td>
                <td className="px-6 py-3">
                  <Select
                    value={o.status}
                    onValueChange={(s) => onStatusChange(o.id, s)}
                  >
                    <SelectTrigger
                      className="w-36 h-8 text-xs"
                      data-testid={`order-status-${o.id}`}
                    >
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {ORDER_STATUSES.map((s) => (
                        <SelectItem key={s} value={s}>
                          {s}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </td>
                <td className="px-6 py-3 text-slate-500 text-xs">
                  {new Date(o.created_at).toLocaleDateString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
